import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useLink } from '~/hooks/link';
import { useNotifications, type ApiOptions } from '../helpers';
import { TransferDeviceDocument } from './transfer.generated';

export const useTransferDevice = (options: ApiOptions<typeof TransferDeviceDocument> = {}) => {
  const { t } = useTranslation();
  const link = useLink();
  const navigate = useNavigate();

  const { onCompleted, onError } = useNotifications(TransferDeviceDocument, {
    failure: t('api.common.error_generic'),
    success: (data) => {
      const network = data.transferDevice?.device?.network.name;
      return t('api.devices.transfer_success', { network });
    },
  });

  return useMutation(TransferDeviceDocument, {
    onCompleted: (data) => {
      onCompleted?.(data);

      const device = data.transferDevice?.device;

      if (device?.network == null) return;

      navigate(link(`/devices/${device.id}/details`, device.network.id), { replace: true });
    },

    onError,

    update(cache, { data }) {
      if (data?.transferDevice?.device == null) return;
      cache.evict({ id: cache.identify(data.transferDevice.device) });
    },

    ...options,
  });
};
